// extracted by mini-css-extract-plugin
export default {"container":"basketmines_container__rFsPC","loading":"basketmines_loading__1dvIO","outerBox":"basketmines_outerBox__E-yzh","innerBox":"basketmines_innerBox__FN4d+"};